import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateTextAutomation as UpdateTextAutomationMutation,
    UpdateTextAutomationVariables as UpdateTextAutomationMutationVariables,
    TextAutomationUpdateInput,
} from 'nutshell-graphql-types';

import {refetchSalesAutomationOpenLeadQueries} from '../../app/sales-automation-open-leads';

import UPDATE_TEXT_AUTOMATION from '../mutations/update-text-automation.graphql';

export const useUpdateTextAutomation = (): {
    updateTextAutomation: (input: TextAutomationUpdateInput, stageId: string) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateTextAutomation, {loading, error}] = useMutation<
        UpdateTextAutomationMutation,
        UpdateTextAutomationMutationVariables
    >(UPDATE_TEXT_AUTOMATION);

    return {
        updateTextAutomation: (input: TextAutomationUpdateInput, stageId: string) => {
            return updateTextAutomation({
                variables: {textAutomation: input},
                // @ts-expect-error
                refetchQueries: refetchSalesAutomationOpenLeadQueries({stageId: stageId}),
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
